import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["item", "label"]

  declare readonly itemTargets: HTMLElement[]
  declare readonly labelTarget: HTMLElement

  private resetTimer?: number

  async copy(): Promise<void> {
    await navigator.clipboard.writeText(this.itemTargets.map((item) => item.textContent?.trim() ?? "").join("\n"))
    this.showCopied()
  }

  disconnect(): void {
    window.clearTimeout(this.resetTimer)
  }

  private showCopied(): void {
    const original = this.labelTarget.dataset.original ?? this.labelTarget.textContent ?? ""
    this.labelTarget.dataset.original = original
    this.labelTarget.textContent = "Copied"
    window.clearTimeout(this.resetTimer)
    this.resetTimer = window.setTimeout(() => {
      this.labelTarget.textContent = original
    }, 2000)
  }
}
